import * as React from 'react'
// libs
import styled, { css } from 'styled-components'
// components
import { Scrollbar as ReactScrollbar } from 'components/UI'
// constants
import { APP_BAR_HEIGHT } from 'constants/layout'
// icons
import BurgerMenuIcon from '@mui/icons-material/MenuOutlined'
// themes
import { colors } from 'themes'
// views
import { StyledAppBar } from 'layouts/MainLayout/AppBar/views'
// utils
import { size } from 'polished'

export const Layout = styled.div<{ onLine }>`
  display: flex;
  flex-direction: column;
  height: 100dvh;

  ${({ onLine }) =>
    !onLine &&
    css`
      ${BWrapper} {
        @media (max-width: 768px) {
          margin-top: 24px;
        }
      }

      ${StyledAppBar} {
        margin-top: 24px;
      }
    `}
`

export const Wrapper = styled.div<{ offset: number }>`
  @media (max-width: 768px) {
    margin-top: 64px;
    padding-left: 0;
  }

  display: flex;
  min-height: calc(100dvh - ${APP_BAR_HEIGHT}px);
  padding-left: ${({ offset }) => offset}px;
  width: 100%;

  transition: ${({ theme }: any) =>
    theme.transitions.create('padding-left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })};
`

export const InnerWrapper = styled.div`
  overflow-y: hidden;
  height: 100%;
  width: 100%;
`

export const Scrollbar = styled((props) => <ReactScrollbar {...props} />)`
  height: 100%;
  width: 100%;

  .ps__rail-x,
  .ps__rail-y {
    z-index: 123;
    position: absolute;
  }
`

export const BWrapper = styled('div')`
  background-color: ${colors.darkBlue500};
  display: none;
  height: 64px;
  position: fixed;
  top: 0;
  z-index: 10;

  @media (max-width: 768px) {
    display: block;
    padding: 20px;
    width: 100%;
  }
`

export const BurgerMenu = styled(BurgerMenuIcon)`
  && {
    cursor: pointer;
    ${size('25px')};
  }
`

export const Backdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 99;

  @media (min-width: 768px) {
    display: none;
  }
`
